import { MapStringTo } from "../base-types";
import { IExtendedContentHubClient } from "../clients/extended-client";
import { IRendition, IRenditionItem, Rendition } from "../contracts/base/rendition";
import Guard from "../guard";
import Link from "../link";

export class RenditionMapper {
    private readonly _client: IExtendedContentHubClient;

    constructor(client: IExtendedContentHubClient) {
        Guard.notNullOrUndefined(client);
        this._client = client;
    }

    mapRenditions(
        id: number,
        extensionData: {
            [key: string]: unknown;
        }
    ): Array<IRendition> {
        if (extensionData == null) return [];

        const renditions = extensionData["renditions"] as MapStringTo<Array<Link>>;

        if (!renditions || Object.keys(renditions).length === 0) return [];

        const list: Array<IRendition> = [];

        for (const renditionName in renditions) {
            const values = renditions[renditionName];
            if (!values || values.length === 0) continue;

            const rendition = Rendition.createRendition(
                renditionName,
                values.map((value: Link): IRenditionItem => {
                    return Link.copyFrom(value);
                })
            );
            list.push(rendition);
        }

        return list;
    }

    mapToResource(renditions: ReadonlyArray<IRendition>): MapStringTo<Array<Link>> {
        const links: MapStringTo<Array<Link>> = {};

        if (renditions == null) {
            return links;
        }

        for (const rendition of renditions) {
            links[rendition.name] = rendition.items.map(i => new Link(i.href));
        }

        return links;
    }
}
